import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { useRemoteResource } from 'hooks/useRemoteResource';
import permissionsSAService from 'services/superadmin/permissionsSAService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Название'
    },
    {
        key: 'resource',
        label: 'Модуль'
    },
    {
        key: 'action',
        label: 'Действия'
    },
]

export const PermissionList = () => {
    const [data, loadData, loading] = useRemoteResource(permissionsSAService.getAll, "");

    const onDelete = async (u) => {
        await permissionsSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Права">
            <AppAdminTable
                columnConfig={listConfig}
                data={data || []}
                onDelete={onDelete}
                loading={loading}
            />
        </ListPage>
    );
}
